/**
 * @memberOf app.accept
 * @name AcceptController
 * @ngdoc controller
 */

export default class AcceptController {

  constructor($state, AuthService, Flash) {

    /**
     * @memberOf AcceptController
     * @type {service}
     * @description Instance of ui-router's $state service
     */
    this.$state = $state;

    /**
     * @memberOf AcceptController
     * @type {service}
     * @description Instance of AuthService
     */
    this.AuthService = AuthService;

    /**
     * @memberOf AcceptController
     * @type {service}
     * @description Instance of ngFlash for flashing error messages
     */
    this.flash = Flash;
  }

  /**
   * @memberOf AcceptController
   * @description User has accepted terms. Changes the state (view) of screen if the user is logged in, go to 'home.'
   * Else go to 'login.'
   */
  changeView() {
    this.AuthService.setDisclaimerAccepted();
    if (this.AuthService.isLoggedIn()) {
      this.$state.go('home');
    } else {
      this.$state.go('login');
    }
    this.flash.clear();
  }

  /**
   * @memberOf AcceptController
   * @description Checks to see if the login was failed (link expired).
   * @returns {Boolean} True if login failed, false otherwise
   */
  isFailedLogin() {
    return this.$state.params.failedLogin;
  }

  /**
   * @memberOf AcceptController
   * @description Creates a flash on the view telling the user the link has expired.
   */
  flashLoginError() {
    let message = 'The login link that you used has expired. Please accept the terms of use and re-enter your email address to receive a new link.';
    this.flash.clear();
    this.flash.create('danger', message, 0, { container: 'invalid' });
  }

}

AcceptController.$inject = ['$state', 'AuthService', 'Flash'];


// WEBPACK FOOTER //
// ./src/client/app/accept/accept.controller.js